export default __webpack_public_path__ + "static/media/divider-1.695857e0.png";